import Vue from 'vue'
import Vuex from 'vuex'

import _ from 'lodash'
import UserModel from './models/UserModel'
import AccountModel from './models/AccountModel'
import CampaignModel from './models/CampaignModel'
import ExportConfigModel from './models/ExportConfigModel';
import ContactModel from "./models/ContactModel";
import GroupModel from "./models/GroupModel";
import MailingModel from "./models/MailingModel";
import {SearchModel} from "./models/SearchModel";

Vue.use(Vuex)

// export default new Vuex.Store({
let store = new Vuex.Store({
  state: {
    debug: true,
    packageVersion: process.env.PACKAGE_VERSION || '0',
    appApiUrl: '',
    appCmsUrl: '',
    appCrmUrl: '',
    oid: 0,
    user: new UserModel(),
    isBusy: false,
    isInit: false,
    _refBusy: 0,
    _refInit: 0,
    networkError: false,
    loginError: 0,
    exportConfigurationItems: [],
    activeExportConfig: new ExportConfigModel(),
    settings: {},
    data: {
      languages: [],
      countries: [],
      fields: [],
      categories: [],
      categoryDict: {},
      messeFilter: '',
      checkMesse: false,
      custom_fields: [],
      additional_fields: [],
      enabled_modules: [], // TBD
      nl_base_link: '',
    },
    rawData: {},
    tabview: {},
    accounts: [], // AccountModel
    searches: [],
    folders: [],
    foldersMap: {},
    campaigns: [], // CampaignModel
    campaign_entries: {
      events: [],
      mailings: []
    },
    isUnsavedXml: false,
    activeCampaign: null,
    contactItems: [],
    selectedContacts: [],
    activeContact: new ContactModel(),
    contactsTotal: 0,
    contactCompany: '',
    groupItem: new GroupModel(),
    mailing: new MailingModel(),
    backMailing: new MailingModel(),
    mSearch: new SearchModel(),
    mSearchBackup: new SearchModel(),
    qsEntries: [],
    companyItems: [],
    mailingTemplates: [],
    templatesFound: 0,
    recipientsCount: {
      show: false,
      unique: 0,
      all: 0,
    },
    searchIsInUse: false,
    searchUsedInMailings: [],
    lang: 2, // 2 = 'en'
    refToolbar: null,
    toolbar: [],
    breadcrumbs: [],
    prevBreadcrumbs: null,
    localeDateFormat: '',
    shouldReloadData: false,
    sendingMailings: [],
    searchReq: {},
    selectedFolder: null,
    selectedCampaignFolder: null,
    exportIds: [],
    allToExport: false,
    selectedItems: [],
    msg: {
      title: '',
      content: '',
      color: '',
    },
    searchesSortBy: [],
    searchesSortDesc: [],
    dndActive: [],
    mStatistics: {},
    contactPage: 1,
    contactItemsPerPage: 100,
  },

  getters: {
    isDebug: state => {
      return process.env.NODE_ENV !== 'production' && !!state.debug
    },
    appVersion: (state) => {
      return state.packageVersion
    },
    appApiUrl: state => {
      return state.appApiUrl
    },
    appCmsUrl: state => {
      return state.appCmsUrl
    },
    appCrmUrl: state => {
      return state.appCrmUrl
    },
    oid: state => {
      return state.oid
    },
    // getOid: state => {
    //   return state.user && state.user.oid ? state.user.oid : state.oid
    // },
    user: state => {
      return state.user
    },
    data: state => {
      return state.data
    },
    settings: state => {
      return state.settings
    },
    user_id: state => {
      // return typeof state.settings.account !== 'undefined' && typeof state.settings.account.id !== 'undefined' ? state.settings.account.id : 0
      return state.user.id
    },
    is_admin: state => {
      return state.user.is_admin == 1
    },
    countries: state => {
      return state.data.countries || []
    },
    languages: state => {
      return state.data.languages || []
    },
    categories: state => {
      return state.data.categories || []
    },
    categoryDict: state => {
      return state.data.categoryDict || {}
    },
    messeFilter: state => {
      return state.data.messeFilter
    },
    checkMesse: state => {
      return state.data.checkMesse
    },
    custom_fields: state => {
      return state.data.custom_fields || []
    },
    tabview: state => {
      return state.tabview || []
    },
    getAccounts: state => {
      return state.accounts || []
    },
    getSearches: state => {
      return state.searches || []
    },
    getFolders: state => {
      return state.folders || []
    },
    getFoldersMap: state => {
      return state.foldersMap || {}
    },
    activeCampaign: state => {
      return state.activeCampaign || new CampaignModel()
    } ,
    getCampaigns: state => {
      return state.campaigns || []
    },
    getCampaignById: state => (id) => {
      return state.campaigns.find(a => a.campaign_id === id) || new CampaignModel()
    },
    campaignEntries: state => {
      return state.campaign_entries.events.concat(state.campaign_entries.mailings)
    },
    getCampaignEvents: state => {
      return state.campaign_entries.events
    },
    getCampaignMailings: state => {
      return state.campaign_entries.mailings
    },
    exportConfigurationItems: state => {
      return state.exportConfigurationItems
    },
    activeExportConfig: state => {
      return state.activeExportConfig
    },
    getAccountById: (state) => (id) => {
      return state.accounts.find(a => a.id == id) || new AccountModel()
    },
    getAccountsById: (state) => (ids) => {
      return state.accounts.filter(a => ids.includes(a.id))
    },
    accounts: (state) => {
      return state.accounts
    },
    getFoldersByAccount: (state) => (id) => {
      return state.folders.filter(a => a.user_id == id)
    },
    getSearchesByAccount: (state) => (id) => {
      return state.searches.filter(a => a.user_id == id)
    },
    // getCampaignsLength: state => {
    campaignEntriesLength: state => {
      return state.campaign_entries.events.length + state.campaign_entries.mailings.length
    },
    getSearchFolders: state => {
      return state.folders.filter(a => a.type === "1")
    },
    getCampaignFolders: state => {
      return state.folders.filter(a => a.type === "2")
    },
    getCategoryById: (state) => (id) => {
// console.log('id: getCategoryById ->: ', id, state.data.categories )
      let category = state.data.categories.find(a => a.id === id)
      if (!category) {
        category = {
          id: id, //a._attributes.id, // xml
          value: `[VALUE]: ${id}`, // a._attributes.id, // xml
          name: `[NAME]: ${id}`, // a._text, // xml
          type: 'cat', // xml
          label: `[LABEL]: ${id}`, // a._text, // +
          text: `[TEXT]: ${id}`, // a._text, // +
          datatype: 'cat', // a._attributes.type ? 'free' : a._attributes.type, // + //// ??
          field: `CAT_${id}`, // `FF_${a._attributes.id}`,
          desc: `[DESC]: ${id}`, // `FF_${a._attributes.id}`,
        }
      }
      return category
    },
    getCategoryByChildId: (state) => (id) => {
      return state.data.categories.find(a => a.children.filter(b => b.id === id).length)
    },
    getCustomFieldById: (state) => (id) => {
// console.log('id: getCustomFieldById ->: ', id, state.data.custom_fields )
      let customFld = state.data.custom_fields.find(a => a.id === id)
      if (!customFld) {
        customFld = {
          id: id, //a._attributes.id, // xml
          value: `[VALUE]: ${id}`, // a._attributes.id, // xml
          name: `[NAME]: ${id}`, // a._text, // xml
          type: 'free', // xml
          label: `[LABEL]: ${id}`, // a._text, // +
          text: `[TEXT]: ${id}`, // a._text, // +
          datatype: 'free', // a._attributes.type ? 'free' : a._attributes.type, // + //// ??
          field: `FF_${id}`, // `FF_${a._attributes.id}`,
          desc: `[DESC]: ${id}`, // `FF_${a._attributes.id}`,
        }
      }
      return customFld
    },
    isUnsavedXml: state => {
      return state.isUnsavedXml
    },
    isBusy: state => {
      return state.isBusy
    },
    isInit: state => {
      return state.isInit
    },
    networkError: state => {
      return state.networkError
    },
    loginError: state => {
      return state.loginError
    },
    contactsTotal: state => {
      return state.contactsTotal
    },
    contactItems: state => {
      return state.contactItems
    },
    selectedContacts: state => {
      return state.selectedContacts
    },
    activeContact: state => {
      return state.activeContact
    },
    contactCompany: state => {
      return state.contactCompany
    },
    groupItem: state => {
      return state.groupItem
    },
    mailing: state => {
      return state.mailing
    },
    backMailing: state => {
      return state.backMailing
    },
    mSearch: state => {
      return state.mSearch
    },
    mSearchBackup: state => {
      return state.mSearchBackup
    },
    qsEntries: state => {
      return state.qsEntries
    },
    companyItems: state => {
      return state.companyItems
    },
    mailingTemplates: state => {
      return state.mailingTemplates
    },
    templatesFound: state => {
      return state.templatesFound
    },
    recipientsCount: state => {
      return state.recipientsCount
    },
    searchIsInUse: state => {
      return state.searchIsInUse
    },
    searchUsedInMailings: state => {
      return state.searchUsedInMailings
    },
    lang: state => {
      return state.lang
    },
    refToolbar: state => {
      return state.refToolbar
    },
    toolbar: state => {
      return state.toolbar
    },
    breadcrumbs: state => {
      return state.breadcrumbs
    },
    prevBreadcrumbs: state => {
      return state.prevBreadcrumbs
    },
    getLocaleDateFormat: state => {
      return state.localeDateFormat
    },
    shouldReloadData: state => {
      return state.shouldReloadData
    },
    sendingMailings: state => {
      return state.sendingMailings
    },
    searchReq: state => {
      return state.searchReq
    },
    selectedFolder: state => {
      return state.selectedFolder
    },
    selectedCampaignFolder: state => {
      return state.selectedCampaignFolder
    },
    exportIds: state => {
      return state.exportIds
    },
    allToExport: state => {
      return state.allToExport
    },
    selectedItems: state => {
      return state.selectedItems
    },
    searchesSortBy: state => {
      return state.searchesSortBy
    },
    searchesSortDesc: state => {
      return state.searchesSortDesc
    },
    dndActive: state => {
      return state.dndActive
    },
    mStatistics: state => {
      return state.mStatistics
    },
    contactPage: state => {
      return state.contactPage;
    },
    contactItemsPerPage: state => {
      return state.contactItemsPerPage;
    },
  },

  mutations: {
    setDebug(state, val) {
      state.debug = val
    },

    setAppApiUrl(state, appApiUrl) {
      state.appApiUrl = appApiUrl
    },
    setAppCmsUrl(state, appCmsUrl) {
      state.appCmsUrl = appCmsUrl
    },
    setAppCrmUrl(state, appCrmUrl) {
      state.appCrmUrl = appCrmUrl
    },
    setOid(state, oid) {
      state.oid = oid
      store._vm.$session.set('oid', oid)
    },
    setUser(state, user) {
      state.user = user
      store._vm.$session.set('user', user)
      // if (user.oid) {
      //   state.oid = user.oid
      // }
    },
    setUserOID(state, oid) {
      state.user.oid = oid
      store._vm.$session.set('user', state.user)
      store.commit('setOid', oid)
    },
    setUserTicket(state, ticket) {
      state.user.ticket = ticket
      store._vm.$session.set('user', state.user)
    },
    setUserItemPerPage(state, val) {
      state.user.results_per_page = val
      store._vm.$session.set('user', state.user)
    },
    clearUser(state) {
      state.user = new UserModel()
    },
    setSettings(state, settings) {
      state.settings = settings
    },
    setDataFields(state, fields) {
      state.data.fields = fields
    },
    setDataCategories(state, categories) {
      state.data.categories = categories
    },
    setCategoryDict(state, categoryDict) {
      state.data.categoryDict = categoryDict
    },
    setMesseFilter(state, filter) {
      state.data.messeFilter = filter
    },
    setCheckMesse(state, check) {
      state.data.checkMesse = check
    },
    setDataCustomFields(state, customFields) {
      state.data.custom_fields = customFields
    },
    setDataAdditionalFields(state, additionalFields) {
      state.data.additional_fields = additionalFields
    },
    setDataNlBaseLink(state, nlBaseLink) {
      state.data.nl_base_link = nlBaseLink
    },
    setDataCountries(state, countries) {
      state.data.countries = countries
    },
    setDataLanguages(state, languages) {
      state.data.languages = languages
    },
    setRawData(state, data) {
      state.rawData = data
    },
    setTabview(state, tabview) {
      state.tabview = tabview
    },
    setAccounts(state, accounts) {
      state.accounts = accounts
    },
    setSearches(state, searches) {
      state.searches = searches
    },
    setFolders(state, {folders, foldersMap}) {
      state.folders = folders
      state.foldersMap = foldersMap
    },
    setCampaigns(state, campaigns) {
      state.campaigns = campaigns
    },
    setCampaignEntries(state, campaign_entries) {
      state.campaign_entries = campaign_entries
    },
    setActiveCampaign(state, campaign) {
      state.activeCampaign = campaign
    },
    setExportConfigurationItems(state, items) {
      state.exportConfigurationItems = items
    },
    setActiveExportConfig(state, item) {
      state.activeExportConfig = item
    },
    networkError(state, val) {
      state.networkError = val
    },
    loginError(state, val) {
      state.loginError = val
    },
    setIsUnsavedXml(state, isUnsavedXml) {
      state.isUnsavedXml = isUnsavedXml
    },
    setContactsTotal(state, val) {
      state.contactsTotal = val
    },
    setContactItems(state, val) {
      state.contactItems = val
    },
    setSelectedContacts(state, val) {
      state.selectedContacts = val
    },
    setActiveContact(state, val) {
      state.activeContact = val
    },
    setGroupItem(state, val) {
      state.groupItem = val
    },
    setMailing(state, val) {
      state.mailing = val
    },
    setBackMailing(state, val) {
      state.backMailing = val
    },
    setMSearch(state, val) {
      state.mSearch = val
      state.mSearchBackup = _.cloneDeep(val)
    },
    setQsEntries(state, val) {
      state.qsEntries = val
    },
    setCompanyItems(state, val) {
      state.companyItems = val
    },
    setContactCompany(state, val) {
      state.contactCompany = val
    },
    setMailingTemplates(state, val) {
      state.mailingTemplates = val
    },
    setTemplatesFound(state, val) {
      state.templatesFound = val
    },
    setRecipientsCount(state, val) {
      state.recipientsCount = val
    },
    setSearchIsInUse(state, val) {
      state.searchIsInUse = val
    },
    setSearchUsedInMailings(state, val) {
      state.searchUsedInMailings = val
    },
    setLang(state, val) {
      state.lang = val
    },
    setRefToolbar(state, val) {
      state.refToolbar = val
    },
    setToolbar(state, val) {
      state.toolbar = val
    },
    setToolbarButton(state, val) {
      const idx = state.toolbar.findIndex(a => a.id === val.id)
      if (idx > -1) {
        state.toolbar[idx] = val
      } else {
        state.toolbar.push(val)
      }
    },
    setBreadcrumbs(state, val) {
      state.breadcrumbs = val
    },
    setPrevBreadcrumbs(state, val) {
      state.prevBreadcrumbs = val
    },

    // --- pseudo-actions ---
    incBusy(state) {
      if (state._refBusy == 0) {
        state.isBusy = true
      }
      state._refBusy += 1;
    },
    decBusy(state) {
      if (state._refBusy == 0) throw "_refBusy: already ZERO!"
      state._refBusy -= 1;
      if (state._refBusy == 0) {
        state.isBusy = false
      }
    },
    setRefBusy(state, val) {
      state._refBusy = val
      if (state._refBusy == 0) {
        state.isBusy = false
      } else {
        state.isBusy = true
      }
    },
    incInit(state) {
      if (state._refInit == 0) {
        state.isInit = false
      }
      if (state._refBusy == 0) {
        state.isBusy = true
      }
      state._refInit += 1
      state._refBusy += 1
    },
    decInit(state) {
      if (state._refInit == 0) throw "_refInit: already ZERO!"
      state._refInit -= 1
      state._refBusy -= 1
      if (state._refInit == 0) {
        state.isInit = true
      }
      if (state._refBusy == 0) {
        state.isBusy = false
      }
    },
    setRefInit(state, val) {
      state._refInit = val
    },
    setIsInit(state, val) {
      state.isInit = val
    },
    setLocaleDateFormat(state, val) {
      state.localeDateFormat = val;
    },
    setShouldReloadData(state, val) {
      state.shouldReloadData = val;
    },
    setSendingMailings(state, val) {
      state.sendingMailings = val
    },
    setSearchReq(state, val) {
      state.searchReq = val
    },
    setSelectedFolder(state, val) {
      state.selectedFolder = val
    },
    setSelectedCampaignFolder(state, val) {
      state.selectedCampaignFolder = val
    },
    setExportIds(state, val) {
      state.exportIds = val
    },
    setAllToExport(state, val) {
      state.allToExport = val
    },
    setSelectedItems(state, val) {
      state.selectedItems = val
    },
    showMessage (state, payload) {
      state.msg.title = payload.title
      state.msg.content = payload.content
      state.msg.color = payload.color
    },
    setSearchesSortBy(state, val) {
      state.searchesSortBy = val
    },
    setSearchesSortDesc(state, val) {
      state.searchesSortDesc = val
    },
    setDndActive(state, val) {
      state.dndActive = val
    },
    setMStatistics(state, val) {
      state.mStatistics = val
    },
    setContactPage(state, val) {
      state.contactPage = val;
    },
    setContactItemsPerPage(state, val) {
      state.contactItemsPerPage = val;
    },
  },

  actions: {
    flagNetworkError(context) {
      context.commit('networkError', true)
    },
    clearNetworkError(context) {
      context.commit('networkError', false)
    },
    clearIsBusy(context) {
      context.commit('setRefBusy', 0)
    },
    resetIsInit(context) {
      context.commit('setRefInit', 0)
      context.commit('setIsInit', false)
    },
    login(context, user) {
      context.commit('setUser', user)
    },
    logout(context) {
      store._vm.$session.remove('user')
      context.commit('clearUser')
    },
    restoreMSearch(context) {
      context.commit('setMSearch', context.getters.mSearchBackup)
    },
  },
})

export default store
